"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_components_1 = require("@carvana/merch-components");
var react_1 = __importDefault(require("react"));
var ModalSections_1 = __importDefault(require("../../../constants/ModalSections"));
var TileDataContext_1 = require("../../TileDataContext");
var Tag_1 = __importDefault(require("../Tag"));
function EvCreditTag() {
    var _a = (0, TileDataContext_1.useTileDataContext)(), vehicleId = _a.tileData.vehicleId, openModal = _a.utils.openModal;
    return (react_1.default.createElement(merch_components_1.Clickable, { "data-analytics-id": null, className: "pointer-events-auto", onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            openModal({ openTo: ModalSections_1.default.EvTax, vehicleId: vehicleId });
        } },
        react_1.default.createElement(Tag_1.default, { tag: "ev", text: "EV Tax Credit", "data-qa": "ev-credit-tag", blueText: true, border: true })));
}
exports.default = EvCreditTag;
//# sourceMappingURL=EvCreditTag.js.map